import React, { useState, useEffect } from "react";
import { apiService } from "../../api/apiService";
import { Link } from "react-router-dom";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";
import { Box, Tab, Tabs, Button, Typography, Paper, Pagination, styled, Modal, DialogActions } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import RoutineStyle from "../../GlobalPolicies/RoutineUpload.module.css";
import ContactusDialog from "./ContactusDialog";
import { borderRadius, display } from "@mui/system";
import uploadedImg from "../../assets/images/img_jobdata.png";
import user from "../../assets/images/dummyUser.jpg";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import DownloadFile from "../../components/Reusable/utils/FilePreview/DownloadFile";


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '1px solid #fff',
  boxShadow: 24,
  borderRadius: '8px',
  p: 2,
};
const HelpSuperAdmin: React.FC = () => {
  const { instance } = useMsal();
  const [uploading, setUploading] = useState(false);

  const [contactData, setContactData] = useState<any[]>([]);
  const [value, setValue] = React.useState('1');
  const [imageSrc, setImageSrc] = useState<string | null>(null);


  const fetchData = async () => {
 
    try {
      const data = await apiService("/ops/contact-us", "GET", undefined, undefined, instance as PublicClientApplication);      
      const moddata = data?.data.map((item: any) => {
        const fileType = item?.doc_path?.split('.').pop();
      
        return {
          ...item,
          'file_type': fileType,
       
        }
      });
  
      setContactData(moddata);
    } catch (error) {
      console.error("Failed to save Vision N Strategy:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleResolveQuery = async (queryId: string) => {
    setUploading(true);
    try {
      await apiService(`/ops/query_resolved/${queryId}`, "PATCH", {}, undefined, instance as PublicClientApplication);

      fetchData();
    } catch (error) {
      console.error("Failed to resolve query:", error);
    } finally {
      setUploading(false);
    }
  };
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);

  // Reusable variable for rendering query cards
  const renderQueryCard = (item: any) => (
    <Paper
      key={item.id}
      sx={{ padding: "20px", marginTop: "20px", marginBottom: "20px", marginLeft: "20px" }}
      elevation={0}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <img src={user} height="50px" alt="User" />
          <Box sx={{ display: "flex", flexFlow: "column", alignItems: "center", justifyContent: "center" }}>
            <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>{item?.created_by}</Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: "600" }}>{item.email_id}</Typography>
          </Box>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Create Date</Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000" }}>
            {new Date(item?.created_at).toLocaleDateString("en-GB")}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Center</Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000" }}>{item?.management}</Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Type of Issue</Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000" }}>{item?.type_of_issue}</Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Status</Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color: item?.status === "Pending" ? "#FF5C00" : "#0E711D",
            }}
          >
            {item?.status}
          </Typography>
        </Box>
      </Box>
      <Box width="auto" sx={{ backgroundColor: "#D4D4D5", height: "1px", my: 0 }} />
      <Box sx={{ mt: "20px" }}>
      <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#616161", mt: "20px" }}>
          <b>Query:</b> {item?.message}
        </Typography>


        {item?.file_type && (
          <Box sx={{width:'40%', height:'100px'}}>
            <DownloadFile
            loading={false}
            error={null}
            name={item?.doc_path.split("/").pop()}
            docPath={item?.doc_path || ''}
           
          />
          </Box>
        )}
       
      </Box>
      <Box sx={{ mt: "20px", display: "flex", justifyContent: "right", width: "100%" }}>
        <Button
          sx={{
            padding: "8px 20px",
            borderRadius: "7px",
            border: "1px solid #000",
            backgroundColor: "#fff",
            marginTop: "20px",
            color: "#000",
          }}
          onClick={() => handleResolveQuery(item?.id)}
          disabled={item?.status === "Resolved" || uploading}
        >
          {uploading ? "Resolving..." : "Resolve"}
        </Button>
      </Box>
    </Paper>
  );

  return (
    <>
      <ActivityBar breadcrumbs={[<Link key="1" to="/">Home</Link>, <Link key="2" to="/">Help</Link>]} />
      <Box sx={{ width: "100%", typography: "body1" }}>
        <Box sx={{ padding: "20px", pt: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>Query Status</Typography>
        </Box>
        {/* <Box sx={{ padding: "20px", pt: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>Query Status</Typography>
                  <Button variant="contained" sx={{ padding: "10px 20px", borderRadius: "5px" }} onClick={handleDialogOpen}>
                    Contact Us
                  </Button>
                </Box> */}
        <TabContext value={value}>

          <Paper sx={{ padding: "20px", pb: "0", marginLeft: "20px" }} elevation={0}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="All" value="1" />
                <Tab label="Pending" value="2" />
                <Tab label="Resolved" value="3" />
              </TabList>
            </Box>
          </Paper>

          <TabPanel value="1">{contactData.map(renderQueryCard)}</TabPanel>
          <TabPanel value="2">
            {contactData.filter((item) => item.status === "Pending").length === 0 && (
              <Typography sx={{ margin: "20px", fontSize: "16px", fontWeight: "600", color: "#000" }}>
                No Pending Queries
              </Typography>
            )}
            {contactData.filter((item) => item.status === "Pending").map(renderQueryCard)}
          </TabPanel>
          <TabPanel value="3">
            {contactData.filter((item) => item.status === "Resolved").length === 0 && (
              <Typography sx={{ margin: "20px", fontSize: "16px", fontWeight: "600", color: "#000" }}>
                No Resolved Queries
              </Typography>
            )}
            {contactData.filter((item) => item.status === "Resolved").map(renderQueryCard)}
          </TabPanel>
        </TabContext>
        <ContactusDialog open={openDialog} onClose={handleDialogClose} />
        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" fontWeight={600} fontSize="18px">
                Uploaded File
              </Typography>

              <img
                src={uploadedImg}
                alt="Uploaded"
                style={{ width: "400px", height: "auto", borderRadius: "8px", marginTop: "10px" }}
              />

              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Message
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#000",
                  border: "1px solid #000",
                  padding: "10px",
                  borderRadius: "5px",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at erat nec ligula
                facilisis tincidunt. Donec ac nunc id enim efficitur facilisis.
              </Typography>

              <DialogActions sx={{ paddingTop: "20px", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{
                    backgroundColor: "#000",
                    color: "#fff",
                    padding: "10px 20px",
                    borderRadius: "5px",
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Box>
          </Modal>
        </div>
      </Box>
    </>
  );
};

export default HelpSuperAdmin;